import moment from 'moment-timezone';

import type {
    AutomaticPricing,
    Pricing,
} from 'web-app/react/profile/child-profile/plans-and-invoices/ad-hoc-purchases/hooks/use-get-automatic-pricing-for-purchases';
import {hasValue} from '@famly/stat_ts-utils_has-value';

import type {PricingGroupForChild} from '../types';

export const transformAutomaticPricingToPricingGroupForChild = (
    automaticPricing: AutomaticPricing,
    automaticRuleGroupId: string,
): null | Array<PricingGroupForChild> => {
    const ruleGroup = automaticPricing.ruleGroups.find(ruleGroup => ruleGroup.ruleGroupId === automaticRuleGroupId);
    if (!ruleGroup) {
        return null;
    }

    return ruleGroup.pricing.map<PricingGroupForChild>(pricing => {
        return {
            type: pricingGroupType(pricing.dates),
            id: pricing.pricingGroupId,
            from: moment(pricing.dates.from),
            to: hasValue(pricing.dates.to) ? moment(pricing.dates.to) : null,
        };
    });
};

const pricingGroupType = (pricingDateRange: Pricing['dates']): PricingGroupForChild['type'] => {
    const currentDate = moment();
    const from = moment(pricingDateRange.from);
    const to = pricingDateRange.to ? moment(pricingDateRange.to) : null;
    if (!hasValue(to)) {
        if (currentDate.isSameOrAfter(from)) {
            return 'current';
        }
        return 'future';
    }

    if (currentDate.isBetween(from, to, 'day', '[]')) {
        return 'current';
    }
    if (currentDate.isBefore(from)) {
        return 'future';
    }

    return 'past';
};
